import React from 'react';
import Svg, { SvgProps, G, Path, Circle } from 'react-native-svg';

export const SvgMenuRH = ({ strokePath, ...props }: SvgProps) => (
  <Svg viewBox="0 0 50 50" width={'100%'} height={'100%'} {...props}>
    <G fill="none" fillRule="evenodd">
      <Path d="M0 0h50v50H0z" />
      <Circle
        stroke={strokePath || props.color}
        strokeWidth={4}
        strokeLinecap="round"
        strokeLinejoin="round"
        cx={25}
        cy={25}
        r={18}
      />
      <Path
        d="M25 13v12l8 4"
        stroke={strokePath || props.color}
        strokeWidth={4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
  </Svg>
);

